import { ActivitySpinnerWidget, Tooltip, TooltipPosition } from '@tableau/widgets';
import React, { ReactElement } from 'react';
import { connect } from 'react-redux';

import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { MapStateToProps } from '~src/commonInfra/utils/ConnectUtils';
import { SessionManagementService } from '~src/sessionManagement/SessionManagementService';

import { ColumnKey, IPrivateConnectionInfo } from '../models/PrivateConnectModels';
import { cellStyle, headerStyle, rowStyle, tableStyle, tooltipCellStyle } from '../styles/PrivateConnectSettingsStyles';
import { PrivateConnectActionMenu } from './PrivateConnectActionMenu';


export interface PrivateConnectionTableOwnProps {
  readonly server: SessionManagementService;
}

export interface PrivateConnectionTableStateProps {
  readonly privateConnections: IPrivateConnectionInfo[];
  readonly isLoading: boolean;
}


export type PrivateConnectionTableProps = PrivateConnectionTableOwnProps & PrivateConnectionTableStateProps;



export interface PrivateConnectionTableState {
    sortOrder: string;
    hasError: boolean;

}

export function getColumnKeys(): ColumnKey[]{
  return [
    {
      name: Messages.column_name(),
      width: '200px'
    },
    {
      name: Messages.column_description(),
      width: '300px'
    },
    {
      name: Messages.column_region(),
      width: '100px'
    },
    {
      name: Messages.column_endpointServiceName(),
      width: '300px'
    },
    {
      name: Messages.column_privateConnectUrl(),
      width: '300px'
    },
    {
      name: Messages.column_actions(),
      width: '100px'
    },
  ];
  }

export class PrivateConnectionTable extends React.PureComponent<PrivateConnectionTableProps, PrivateConnectionTableState> {
  private unmounted: boolean = false;


  private initialState: PrivateConnectionTableState = {
    sortOrder: 'asc',
    hasError: false
  };


  public constructor(props: PrivateConnectionTableProps) {
    super(props);
    this.state = this.initialState;
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }


  public render() {
    if(this.props.isLoading){
      return(
        <div style={{paddingRight: '50px'}}>
          <table style={tableStyle}>
            {this.getTableHeaders()}
            </table>
            <div data-tb-test-id style={{textAlign: 'center'}}>
              <ActivitySpinnerWidget style={{textAlign:'center', marginTop: '30px'}} testId='test'></ActivitySpinnerWidget>
            </div>
        </div>
      );
    }else{
      return (
        <div style={{paddingRight: '50px'}}>
          <table style={tableStyle}>
            {this.getTableHeaders()}
            <tbody>
              {this.props.privateConnections.map((row, index) => (
                <tr key={index} style={rowStyle}>
                  <td style={cellStyle}>{row.name}</td>
                  <td style={cellStyle}>
                    {this.getTooltip(row.description)}
                  </td>
                  <td style={cellStyle}>{row.region}</td>
                  <td style={cellStyle}>
                    {this.getTooltip(row.endpointServiceName)}
                  </td>
                  <td style={cellStyle}>
                    {this.getTooltip(row.dnsName)}
                  </td>
                  <td style={cellStyle}>
                    <PrivateConnectActionMenu privateConnection={row} server={this.props.server} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  }

  private getTooltip(value: string): ReactElement<Tooltip> {
    return (
      <Tooltip
          position={TooltipPosition.Bottom}
          afterDelay={true}
          tooltipContent={value}
          onlyShowWhenClipped={true}
        >
          <div style={tooltipCellStyle}>{value}</div>
      </Tooltip>
    );
  }

  private getTableHeaders() {
    return (
      <thead>
        <tr style={rowStyle}>
          {getColumnKeys().map((header, index) => (
            <th key={index} style={{ ...headerStyle, width: header.width }}>
              {header.name}
            </th>
          ))}
        </tr>
      </thead>
    );
  }
}

const mapStateToProps: MapStateToProps<PrivateConnectionTableStateProps> = (state: AppState) => ({
  privateConnections: state.privateConnectInfo.privateConnections,
  isLoading: state.privateConnectInfo.isFetchingPrivateConnections,

});

export const ConnectedPrivateConnectionTable: React.ComponentClass<PrivateConnectionTableOwnProps> =
  connect(mapStateToProps)(PrivateConnectionTable);
